<script>
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import {required, email} from "vuelidate/lib/validators";
export default {
  components: {Multiselect},
  page: {
    title: "Xác nhận ký số",
    meta: [{name: "description", content: appConfig.description}],
  },
  data() {
    return {
      title: "Xác nhận ký số",
      optionsDonVi: [],
      model:{
        appleId: null,
        fullName: null,
        donVi: null,
        ghiChu: null
      },
      submitted: false
    }
  },
  validations: {
    model: {
      appleId: {required, email},
      fullName: {required},
      donVi: {required}
    },
  },
  created() {
    this.getDonVi();
  },
  methods: {
    async getDonVi() {
      try {
        await this.$store.dispatch("donViStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.optionsDonVi = items;
          }
          return [];
        });
      }catch (e) {
        console.log("Error", e)
      }
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      console.log("this.$v.$invalid", this.$v.$invalid)
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });

        await this.$store.dispatch("appleConnectorStore/create", this.model).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showModal = false;
            this.$swal({
              position: 'center',
              icon: 'success',
              title: 'Đăng ký Apple Connector thành công',
              showConfirmButton: true,
              backdrop: true,
              allowOutsideClick: false,
              confirmButtonText: 'Đồng ý',
            }).then((result) => {
              // Kiểm tra xem người dùng đã nhấp vào nút "OK" hay không
              if (result.isConfirmed) {
                this.model = {
                  appleId: null,
                  fullName: null,
                  donVi: null,
                  ghiChu: null
                }
              }
            });
          }else{
            this.$swal({
              position: 'center',
              icon: 'error',
              title: 'Đăng ký Apple Connector thất bại',
              showConfirmButton: true,
              backdrop: true,
              allowOutsideClick: false,
              confirmButtonText: 'Đồng ý',
            });
          }
          // this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
        });
        loader.hide();
      }
      this.submitted = false;
    },
  }
}
</script>
<template>
  <div>
    <section>
      <div class="col-12 text-center bg-xac-nhan">
      </div>
      <div class="row d-flex justify-content-center" style=" --bs-gutter-x: 0">
        <div class="col-md-6 col-xs-12 col-sm-12 p-0 col-lg-4" style="margin-top: -500px;">
          <b-card style="border-radius: 10px;">
            <b-card-body>
              <div class="home-wrapper mt-1 text-center">
                <div class="">
                  <img
                      src="@/assets/images/d-office.png"
                      alt="logo"
                      height="50"
                      class="text-white"
                  />
                </div>
                <h3 class="mt-2 mb-4 text-primary">Apple Store Connector</h3>

                <div class="row justify-content-center">
                  <div class="text-center col-md-12">
                    <div class="my-1">
                      <div class="d-flex justify-content-start align-items-baseline">
                        <i class="fab fa-apple me-1"></i>
                        <h6 class="fw-bold">Apple ID</h6>
                        <span
                            class="text-danger mx-1"> (*)</span>
                      </div>
                      <input
                          size="sm"
                          type="email"
                          name="untyped-input"
                          class="form-control"
                          placeholder="Hãy nhập Apple ID"
                          v-model="model.appleId"
                          :class="{'is-invalid': submitted && $v.model.appleId.$error,}"
                      />
                      <div
                          v-if="submitted && $v.model.appleId.$error"
                          class="invalid-feedback text-start"
                      >
                        <span v-if="!$v.model.appleId.required">Apple ID không được trống.</span>
                        <span v-if="!$v.model.appleId.email">Apple ID không hợp lệ</span>
                      </div>
                    </div>

                  </div>

                  <div class="text-center col-md-12">
                    <div class="my-1">
                      <div class="d-flex justify-content-start align-items-baseline">
                        <i class="fas fa-user-edit me-1"></i>
                        <h6 class="fw-bold">Họ và tên</h6>
                        <span
                            class="text-danger mx-1"> (*)</span>
                      </div>
                      <input
                          size="sm"
                          type="text"
                          name="untyped-input"
                          class="form-control"
                          placeholder="Hãy nhập thông tin "
                          v-model="model.fullName"
                          :class="{'is-invalid': submitted && $v.model.fullName.$error,}"
                      />
                      <div
                          v-if="submitted && $v.model.fullName.$error"
                          class="invalid-feedback text-start"
                      >
                        <span v-if="!$v.model.fullName.required">Họ và tên không được trống.</span>
                      </div>
                    </div>

                  </div>

                  <div class="text-center col-md-12">
                    <div class="my-2">
                      <div class="d-flex justify-content-start align-items-baseline">
                        <i class="fas fa-users me-1"></i>
                        <h6 class="fw-bold"> Đơn vị</h6>
                        <span
                            class="text-danger mx-1"> (*)</span>
                      </div>
                      <multiselect
                          :options="optionsDonVi"
                          track-by="id"
                          label="ten"
                          placeholder="Chọn đơn vị công tác"
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                          v-model="model.donVi"
                          :class="{'is-invalid': submitted && $v.model.donVi.$error,}"
                      ></multiselect>
                      <div
                          v-if="submitted && !$v.model.donVi.required"
                          class="invalid-feedback text-start"
                      >
                         Đơn vị không được để trống.
                      </div>
                    </div>
                  </div>
                  <div class="text-center col-md-12">
                    <div class="my-2">
                      <div class="d-flex justify-content-start align-items-baseline">
                        <i class="fas fa-sticky-note me-1"></i>
                        <h6 class="fw-bold">Ghi chú</h6>
                      </div>
                      <textarea
                          size="sm"
                          type="text"
                          class="form-control"
                          placeholder="Hãy nhập ghi chú"
                          rows="4"
                          v-model="model.ghiChu"
                      > </textarea>
                    </div>
                  </div>
                  <div class="text-center col-md-8">
                    <div class=" mt-4">
                      <b-button
                          @click="handleSubmit"
                          variant="primary"
                          class="mb-2 w-100"
                          style="border-radius: 99px;"
                      >
                        <i class="fas fa-marker"></i>
                        Gửi thông tin
                      </b-button>
                    </div>
                  </div>
                </div>
                <!-- end row -->
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
.bg-xac-nhan {
  background: url("../../assets/images/background_ios.png");
  height: 600px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

@media only screen and (max-width: 425px) {
  .logo-eoffice {
    height: 60px;
    margin-bottom: -80px;
  }
}

@media only screen and (max-width: 375px) {
  .logo-eoffice {
    height: 60px;
    margin-bottom: -80px;
  }
}

@media only screen and (max-width: 320px) {
  .logo-eoffice {
    height: 60px;
    margin-bottom: -80px;
  }
}
</style>
